import styled from "styled-components"

export const CardsSectionWrapper = styled.div`
	width: 100%;
	background-color: #ffffff;
	padding: 24px;
	border-radius: 16px;
	display: flex;
	justify-content: space-between;
	gap: 16px;
	div {
		&:first-child {
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			gap: 16px;
			p {
				margin: 0;
				&:first-child {
					color: #435363;
					font-weight: 400;
					font-size: 14px;
					line-height: 16.8px;
				}
				&:last-child {
					color: #5b3fff;
					font-weight: 700;
					font-size: 32px;
					line-height: 38.4px;
				}
			}
		}
		&:last-child {
			display: flex;
			justify-content: center;
			align-items: center;
			svg {
				width: 32px;
				height: 32px;
			}
		}
	}
`
